import { ThemeValues } from '../constants/themes'

export function setTheme (themeId) {
  if (!themeId) {
    themeId = 0
  }
  let theme = ThemeValues.find(obj => {
    return obj.themeId === themeId
  }).description

  document.documentElement.setAttribute('data-theme', theme)
  localStorage.setItem('theme', theme)
}

export function setThemeClass (themeClass) {
  if (themeClass) {
    document.documentElement.setAttribute('data-theme', themeClass)
  }
}
